"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBarMenuItems = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuItems = require("design_system/Menu/MenuItems");
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  position: "justify-between overflow-hidden",
  p: "py-0 s768:py-8",
  bg: "bg-transparent s768:bg-white",
  shadow: "shadow-none s768:shadow-0-4-5-0-fff"
};
const NavBarMenuItems = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    ...props
  } = _ref;
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const isNarrowScreen = width > 0 && width < _useResizeObserver.BREAKPOINTS.s768;
  return /*#__PURE__*/_react.default.createElement(_MenuItems.MenuItems, _extends({
    keepMounted: isNarrowScreen,
    ref: ref,
    p: THEME.p,
    bg: THEME.bg,
    shadow: THEME.shadow,
    className: (0, _classnames.default)(THEME.position, className)
  }, props), children);
});
exports.NavBarMenuItems = NavBarMenuItems;
NavBarMenuItems.displayName = "NavBar.MenuItems";